module.exports = __webpack_public_path__ + "../web/img/logo.39eb2cc5.png";